/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Orders_Already_In_StatusInputs */

const en_orders_already_in_status = /** @type {(inputs: Orders_Already_In_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} already in status`)
};

const es_orders_already_in_status = /** @type {(inputs: Orders_Already_In_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} ya estan en ese estado`)
};

/**
* | output |
* | --- |
* | "{count} already in status" |
*
* @param {Orders_Already_In_StatusInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_already_in_status = /** @type {((inputs: Orders_Already_In_StatusInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Already_In_StatusInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_already_in_status(inputs)
	return es_orders_already_in_status(inputs)
});